import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export default new VueI18n({
  locale: "cs",
  fallbackLocale: "cs",
  messages: {},
  numberFormats: {
    cs: {
      currency: {
        style: "currency",
        currency: "CZK",
      },
    },
  },
  pluralizationRules: {
    cs: (choice: number, choicesLength: number): number => {
      choice = Math.abs(choice);
      const index = choice === 1 ? 0 : choice >= 2 && choice <= 4 ? 1 : 2;
      return Math.min(index, choicesLength);
    },
    sk: (choice: number, choicesLength: number): number => {
      choice = Math.abs(choice);
      const index = choice === 1 ? 0 : choice >= 2 && choice <= 4 ? 1 : 2;
      return Math.min(index, choicesLength);
    },
  },
});
